//보상 목록
const reward_list = {
    "lineage":`
                <dl>
                    <dt>1일차</dt>
                    <dd>메티스의 정성스러운 스프 10개</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>메티스의 정성스러운 스프 10개</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>퓨어 엘릭서(EXP) 1개</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>메티스의 정성스러운 스프 10개</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>메티스의 정성스러운 스프 10개</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>퓨어 엘릭서 1개</dd>
                </dl>`,
    "lineage2":`
                <dl>
                    <dt>본서버(아덴/자켄/윈드/데스/전설/영웅/실프/신화/오크) 1일차</dt>
                    <dd>공격력 강화 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(말하는섬) 1일차</dt>
                    <dd>빛나는 무디의 멜로디 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(지그하르트/바츠/카인/리오나/에리카) 1일차</dt>
                    <dd>프레야의 얼음장미(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(아덴/자켄/윈드/데스/전설/영웅/실프/신화/오크) 2일차</dt>
                    <dd>공격력 강화 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(말하는섬) 2일차</dt>
                    <dd>빛나는 무디의 멜로디 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(지그하르트/바츠/카인/리오나/에리카) 2일차</dt>
                    <dd>프레야의 얼음장미(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(아덴/자켄/윈드/데스/전설/영웅/실프/신화/오크) 3일차</dt>
                    <dd>사이하의 폭풍 Lv3(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(말하는섬) 3일차</dt>
                    <dd>사이하의 폭풍 Lv3(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(지그하르트/바츠/카인/리오나/에리카) 3일차</dt>
                    <dd>프레야의 폭풍 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(아덴/자켄/윈드/데스/전설/영웅/실프/신화/오크) 4일차</dt>
                    <dd>공격력 강화 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(말하는섬) 4일차</dt>
                    <dd>빛나는 무디의 멜로디 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(지그하르트/바츠/카인/리오나/에리카) 4일차</dt>
                    <dd>프레야의 얼음장미(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(아덴/자켄/윈드/데스/전설/영웅/실프/신화/오크) 5일차</dt>
                    <dd>공격력 강화 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(말하는섬) 5일차</dt>
                    <dd>빛나는 무디의 멜로디 주문서(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(지그하르트/바츠/카인/리오나/에리카) 5일차</dt>
                    <dd>프레야의 얼음장미(각인) 20개</dd>
                </dl>
                <dl>
                    <dt>본서버(아덴/자켄/윈드/데스/전설/영웅/실프/신화/오크) 6일차</dt>
                    <dd>사이하의 폭풍 Lv3(각인) 20개, 은총 쿠키(각인) 50개</dd>
                </dl>
                <dl>
                    <dt>본서버(말하는섬) 6일차</dt>
                    <dd>사이하의 폭풍 Lv3(각인) 20개, 은총 쿠키(각인) 50개</dd>
                </dl>
                <dl>
                    <dt>본서버(지그하르트/바츠/카인/리오나/에리카) 6일차</dt>
                    <dd>프레야의 폭풍 주문서(각인) 20개, 제왕의 활력수(각인) 50개</dd>
                </dl>`,
    "aion":`
                <dl>
                    <dt>라이브 1일차</dt>
                    <dd>[이벤트]단디의 응원구슬 2개</dd>
                </dl>
                <dl>
                    <dt>클래식 2일차</dt>
                    <dd>[이벤트]상급 질주의 주문서 20개, [이벤트]상급 용기의 주문서 20개, [이벤트]상급 각성의 주문서 20개</dd>
                </dl>
                <dl>
                    <dt>라이브 2일차</dt>
                    <dd>[이벤트]재빠른 단디 캔디 10개 상자 1개</dd>
                </dl>
                <dl>
                    <dt>클래식 2일차</dt>
                    <dd>[이벤트]재빠른 단디 캔디 10개 상자 1개</dd>
                </dl>
                <dl>
                    <dt>라이브 3일차</dt>
                    <dd>[이벤트]다이노스 복식 1개, [이벤트]다이노스 모자 1개</dd>
                </dl>
                <dl>
                    <dt>클래식 3일차</dt>
                    <dd>[이벤트]다이노스 복식 1개, [이벤트]다이노스 모자 1개</dd>
                </dl>
                <dl>
                    <dt>라이브 4일차</dt>
                    <dd>A등급 미니움 100개</dd>
                </dl>
                <dl>
                    <dt>클래식 4일차</dt>
                    <dd>[이벤트]스티그마 샤드 2000개</dd>
                </dl>
                <dl>
                    <dt>라이브 5일차</dt>
                    <dd>[이벤트]야구 행위예술 카드 선택 상자 1개</dd>
                </dl>
                <dl>
                    <dt>클래식 5일차</dt>
                    <dd>[이벤트]궁극의 PVE 강화석(7일) 1개</dd>
                </dl>
                <dl>
                    <dt>라이브 6일차</dt>
                    <dd>[이벤트]궁극의 PVE 강화석(7일) 1개</dd>
                </dl>
                <dl>
                    <dt>클래식 6일차</dt>
                    <dd>[이벤트]염색약 : 로맨틱 핑크 2개</dd>
                </dl>`,
    "bns":`
                <dl>
                    <dt>1일차</dt>
                    <dd>홍문신공 쾌속 성장부적 5개</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>홍문신공 쾌속 성장부적 5개</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>빛나는 홍문신공 쾌속 성장부적 1개, 독각대왕 소주 3개</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>홍문신공 쾌속 성장부적 5개</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>홍문신공 쾌속 성장부적 5개</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>빛나는 홍문신공 쾌속 성장부적 1개, 독각대왕 소주 5개</dd>
                </dl>`,
    "bufftoon":`
                <dl>
                    <dt>1일차</dt>
                    <dd>100코인</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>100코인</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>100코인</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>100코인</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>100코인</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>100코인</dd>
                </dl>`,
    "lineagem":`
                <dl>
                    <dt>1일차</dt>
                    <dd>드래곤의 진주(이벤트) 10개</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>드래곤의 다이아몬드(이벤트) 3개</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>전투 강화의 주문서(이벤트) 5개</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>메티스의 요리(이벤트) 20개</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>명예코인 2000개</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>구호증서(이벤트) 1개</dd>
                </dl>`,
    "lineage2m":`
                <dl>
                    <dt>1일차</dt>
                    <dd>아인하사드의 은총 2000개, 상급 집혼석(11회) 1개</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>아인하사드의 은총 2000개, 상급 집혼석(11회) 1개</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>아인하사드의 은총 2000개, 상급 클래스 획득권(11회) 1개</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>아인하사드의 은총 2000개, 상급 집혼석(11회) 1개</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>아인하사드의 은총 2000개, 상급 집혼석(11회) 1개</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>아인하사드의 은총 2000개, 상급 아가시온 획득권(11회) 1개</dd>
                </dl>`,
    "tricksterm":`
                <dl>
                    <dt>1일차</dt>
                    <dd>상급 패션 소환(10회)(이벤트) 1개</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>500,000 겔더</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>네페트리의 귀걸이 박스(귀속) 1개, 포르티나의 귀걸이 박스(귀속) 1개</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>상급 펫 소환(10회)(이벤트) 1개</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>수호석(귀속) 10개, 정령석(귀속) 10개</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>영광의 중상급 패션 소환(10회)(이벤트)</dd>
                </dl>`,
    "h2":`
                <dl>
                    <dt>1일차</dt>
                    <dd>특수능력 슈퍼레어 온리팩 5개</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>특수능력 익스 온리팩 1개</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>특수능력 익스 온리팩(투수) 1개</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>특수능력 익스 온리팩(타자) 1개</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>특수능력 익스 온리팩(태생 RED~EX) 1개</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>특능 태생 EX팩(ONLY EX) 1개</dd>
                </dl>`,
    "h3":`
                <dl>
                    <dt>1일차</dt>
                    <dd>선호구단 스카우터x5(이적불가) 2개</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>프리미엄 콜업 팩 3개</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>프리미엄 특수능력팩(거래불가) 3개</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>프리미엄 장비팩(거래불가) 3개</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>선수강화권 3개</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>선호구단 골든글러브 스카우터(이적불가) 1개</dd>
                </dl>`,
    "bns2":`
                <dl>
                    <dt>1일차</dt>
                    <dd>방어구 강화 주문서(이벤트) 5개</dd>
                </dl>
                <dl>
                    <dt>2일차</dt>
                    <dd>무기 강화 주문서(이벤트) 3개</dd>
                </dl>
                <dl>
                    <dt>3일차</dt>
                    <dd>빛나는 소울 소환서(1회)(이벤트) 2개</dd>
                </dl>
                <dl>
                    <dt>4일차</dt>
                    <dd>방어구 강화 주문서(이벤트) 5개</dd>
                </dl>
                <dl>
                    <dt>5일차</dt>
                    <dd>무기 강화 주문서(이벤트) 3개</dd>
                </dl>
                <dl>
                    <dt>6일차</dt>
                    <dd>빛나는 소울 소환서(11회)(이벤트) 1개</dd>
                </dl>`
};

export default reward_list;


// WEBPACK FOOTER //
// ./src/js/func/reward_list.js